export { default as isDocumentFragment } from './typeUtils/isDocumentFragment';
export { default as isHTMLElement } from './typeUtils/isHTMLElement';
export { default as isHTMLOListElement } from './typeUtils/isHTMLOListElement';
export { default as isHTMLTableCellElement } from './typeUtils/isHTMLTableCellElement';
export { default as isHTMLTableElement } from './typeUtils/isHTMLTableElement';
export { default as isNode } from './typeUtils/isNode';
export { default as isRange } from './typeUtils/isRange';
